var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.653 15.64 9.11 4.627c-.467-2.288-4.378-2.288-4.824 0l-2.15 11.274m11.212-.263 1.558-11.011c.398-2.319 4.338-2.505 4.823 0l2.15 11.274M9.73 8.798c1.159-.534 3.265-.582 4.548 0m-5.483 7.64c.062.62-.219 1.196-.7 1.576m-1.481 1.229h.032m3.413-8.066c1.133-.455 2.793-.471 3.887 0m5.948 5.26c.062.621-.218 1.197-.7 1.577m-1.39 1.229h.032M6.444 21.182C3.99 21.182 2 19.097 2 16.912c0-2.183 1.99-4.196 4.444-4.196 2.455 0 4.445 2.013 4.445 4.197s-1.99 4.269-4.445 4.269Zm11.112 0c-2.455 0-4.445-2.085-4.445-4.27 0-2.183 1.99-4.196 4.445-4.196 2.454 0 4.444 2.013 4.444 4.197s-1.99 4.269-4.444 4.269Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.599683b4346232e7cd99db8866dedba3.svg";
export { ForwardRef as ReactComponent };